// Select the toggle trigger
const toggle = document.querySelector(".aside__header");
const asideBackdrop = document.querySelector(".aside__backdrop");

function toggleAside() {
    if (document.body.classList.contains("aside-open")) {
        document.body.classList.remove("aside-open");
    } else {
        document.body.classList.add("aside-open");
    }
}


// Toggle body class 'aside-open'
if (toggle) {
    toggle.addEventListener("click", toggleAside);
}

// Close aside on click on backdrop
if (asideBackdrop) {
    asideBackdrop.addEventListener("click", function () {
        toggleAside();
    });
}